import { styled } from '@mui/system';
import colors from '../../../../theme/emotion/colors';

export const OnboardingContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
  overflow: 'hidden',
  backgroundColor: colors.neutral.grey,
  position: 'relative',
  '@supports (height: 100dvh)': {
    height: '100dvh',
  },
});

export const OnboardingScrollContainer = styled('div')({
  flex: 1,
  overflowY: 'auto',
  paddingBottom: '6rem', // Space for fixed button
  display: 'flex',
  flexDirection: 'column',
  WebkitOverflowScrolling: 'touch', // Smooth scrolling on iOS
});

export const OnboardingContentSection = styled('div')({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-start', // Changed from center to flex-start
  padding: '4rem 1.25rem 2rem', // Increased top padding
  gap: '2rem',
  minHeight: 'auto', // Changed from calc(100vh - 6rem)
  '@media (max-height: 700px)': {
    padding: '2rem 1.25rem 2rem',
  },
});

export const OnboardingTitleSection = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  gap: '0.5rem',
  marginBottom: '1rem', // Reduced from 2rem
  width: '100%',
  maxWidth: '28rem',
}); 